import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TransactionInfoService } from 'src/app/services/transaction-info.service';
import { ClaimTypes } from 'src/app/model/claim-type.model';

@Component({
    selector: 'app-burglary',
    templateUrl: './burglary.component.html',
    styleUrls: ['./burglary.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BurglaryComponent implements OnInit {

  constructor( private transactionInfoService: TransactionInfoService) {
      this.transactionInfoService.getTransactionInfo().setCurrentClaimType(ClaimTypes[ClaimTypes.CLAIM_TYPE_HOME_BURGLARY]);
  }

  ngOnInit() {
  }

}


